/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_Minutes_OtherInputs */

const en_us2_quick_workout_minutes_other = /** @type {(inputs: Quick_Workout_Minutes_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const pt_br2_quick_workout_minutes_other = /** @type {(inputs: Quick_Workout_Minutes_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro`)
};

const es_419_quick_workout_minutes_other = /** @type {(inputs: Quick_Workout_Minutes_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otro`)
};

const pt_pt2_quick_workout_minutes_other = /** @type {(inputs: Quick_Workout_Minutes_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro`)
};

const fr_fr2_quick_workout_minutes_other = /** @type {(inputs: Quick_Workout_Minutes_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autre`)
};

const de_de2_quick_workout_minutes_other = /** @type {(inputs: Quick_Workout_Minutes_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere`)
};

const it_it2_quick_workout_minutes_other = /** @type {(inputs: Quick_Workout_Minutes_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altro`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Quick_Workout_Minutes_OtherInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_minutes_other = /** @type {((inputs?: Quick_Workout_Minutes_OtherInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Minutes_OtherInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_minutes_other(inputs)
	if (locale === "es-419") return es_419_quick_workout_minutes_other(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_minutes_other(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_minutes_other(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_minutes_other(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_minutes_other(inputs)
	return en_us2_quick_workout_minutes_other(inputs)
});
export { quick_workout_minutes_other as "quick-workout.minutes_other" }